import type { SubordinateReportRow } from '@/utils/leader-team';

interface SubordinateStatusCardProps {
  row: SubordinateReportRow;
  departmentName?: string;
  onClick?: () => void;
}

export function SubordinateStatusCard({ row, departmentName, onClick }: SubordinateStatusCardProps) {
  const { user, submitted, report } = row;

  return (
    <article
      className="mobile-card"
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(event) => {
        if (onClick && (event.key === 'Enter' || event.key === ' ')) {
          onClick();
        }
      }}
    >
      <div className="mobile-card__header">
        <span className="mobile-card__title">{user.name}</span>
        <span className={submitted ? 'mobile-tag mobile-tag--primary' : 'mobile-tag mobile-tag--warning'}>
          {submitted ? '已交' : '未交'}
        </span>
      </div>
      <div className="mobile-card__meta">
        {departmentName ?? '—'}
        {user.jobTitle ? ` · ${user.jobTitle}` : ''}
      </div>
      {submitted && report ? (
        <p className="mobile-card__body">{report.todayWork}</p>
      ) : (
        <p className="mobile-card__body" style={{ color: '#888' }}>
          该日期尚未提交日报
        </p>
      )}
    </article>
  );
}
